import React, { useCallback, useMemo } from 'react'
import { hooks } from '@front/volcanion'

import Callbacks from './callbacks'
import FormatUtils from '@front/squirtle/utils/format'

const withContainer = Component => props => {
  const [, { openDialog }] = hooks.useDialogs()
  const [isReadOnly] = hooks.useFormState('isReadOnly')
  const [isManagingRecord] = hooks.useFormState('isManagingRecord')
  const [status] = hooks.useFieldValues(['status'])
  const CODE_INTERNATIONAL = hooks.useRelayConstant('CODE_INTERNATIONAL')
  const [user] = hooks.useActiveUser({ mutator: 'user_id' })
  const [selectedCompany] = hooks.useGlobalState('persist.selectedCompany')
  const [administration_level] = hooks.useModelSearch('companyuser', 'get', {
    initial_filter: { user, company: selectedCompany },
    forced_filter: { user, company: selectedCompany },
    populate: ['user'],
    mutator: 'administration_level',
    single: true
  })

  const normalizePhone = useCallback(Callbacks.normalizePhoneHandler(CODE_INTERNATIONAL), [CODE_INTERNATIONAL])
  const color = useMemo(() => FormatUtils.getStatusColor(status), [status])

  const onResetIdentifier = useCallback(() => {
    openDialog('confirmation_reset')
  }, [])

  const displayIdentifierPin = administration_level === 'company'

  const mergedProps = {
    onResetIdentifier,
    normalizePhone,
    isManagingRecord,
    isReadOnly,
    status,
    color,
    displayIdentifierPin
  }

  return (
    <Component {...mergedProps} {...props} />
  )
}

export default withContainer
